import { useEffect, useMemo } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tabs } from "@/components";

const Support = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/support") {
      navigate("/support/escalations", { replace: true }); // Prevents unnecessary history entries
    }
  }, [location.pathname, navigate]);

  const tabs = useMemo(
    () => [
      { label: "Escalations", link: "escalations" },
      { label: "Callback Requests", link: "callbackRequests" },
      { label: "Career", link: "career" },
      { label: "Contact", link: "contacts" },
    ],
    []
  );

  return (
    <div className="w-full flex-1 flex flex-col pb-20 md:pb-4 relative max-w-[2000px]">
      <Tabs tabs={tabs} NavLink={NavLink} />
      <Outlet />
    </div>
  );
};

export default Support;
